// IE 2026 09 20 / ODOO-5800 (Igor: переходы чипса метрик по ячейкам, подсветка параметра ячейки и подпадающих ячеек по наведению на чипс)
// Общий реестр диапазонов текста «попадание чипса метрик» по гридам: CSS.highlights один на документ — грид, вызвавший set() последним, стирал бы
// подсветку остальных. Два слоя: metric-hit — все видимые подпадающие ячейки (наведение на чипс), metric-hit-cur — текущая остановка ‹ ›
const reg = { all: new Map(), cur: new Map() }
function rebuild(kind, name, priority) {
    const CSSH = (typeof window !== 'undefined') && window.CSS && window.CSS.highlights
    if (!CSSH || typeof window.Highlight !== 'function') return false
    const ranges = []
    for (const list of reg[kind].values()) ranges.push(...list)
    if (!ranges.length) { CSSH.delete(name); return true }
    const h = new window.Highlight(...ranges)
    h.priority = priority
    CSSH.set(name, h)
    return true
}
export function metricHit_ranges(gridKey, all, cur) {
    if (all && all.length) reg.all.set(gridKey, all); else reg.all.delete(gridKey)
    if (cur && cur.length) reg.cur.set(gridKey, cur); else reg.cur.delete(gridKey)
    rebuild('all', 'metric-hit', 1)
    return rebuild('cur', 'metric-hit-cur', 2)
}
export function metricHit_count(kind) { let n = 0; for (const list of reg[kind === 'cur' ? 'cur' : 'all'].values()) n += list.length; return n }
